export default {
  key: 'C',
  suffix: '11',
  positions: [{
    frets: '7567',
    fingers: '3124'
  }]
};